import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import MediaQuery from 'react-responsive';
const MediaQuerySmallDeviceHoc = (ChildComponent) => (props) => (_jsx(MediaQuery, Object.assign({ minWidth: 480 }, { children: (matches) => _jsx(ChildComponent, Object.assign({}, props, { isSmall: !matches })) })));
export default MediaQuerySmallDeviceHoc;
